<script>
import Slick from "vue-slick";
import VueScrollTo from 'vue-scrollto';

export default {
  data() {
    return {
      slickOptions: {
        //options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: false,
        accessibility: true,
        adaptiveHeight: window.innerWidth < 768 ? true : false,
        arrows: true,
        dots: true,
        draggable: false,
        edgeFriction: 0.3,
        swipe: true
      }
    };
  },
  methods: {
    handleInit(event, slick) {
      slick.$dots.append('<li class="count-max">'+ slick.slideCount +'</li>');
      document.getElementById('scrollTrigger').click();
    },
  },
  components: {
    slick: Slick
  }
};
</script>

<template>
  <article id="article_numeri" class="do-article">
    <a class="hidden" id="scrollTrigger" v-scroll-to="{ el: '#article_numeri', duration: 1 }"></a>
    <div class="row no-gutters">
      <div class="col-xl-4 col-lg-5">
        <div class="do-article-info">
          <progressive-background src="static/images/article4.png"/>
          <h2>PAURA DEI NUMERI?</h2>
          <p>I
            <strong>dati di settore</strong> permettono una visione meno parziale,
            <strong>più oggettiva</strong> di questo materiale.
          </p>
          <p>Tutti i numeri della plastica per supportarti in 
            un'<strong>analisi accurata e consapevole.</strong>
          </p>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7">
        <div class="do-article-content">
          <router-link class="do-back" to="/">
            <img src="static/images/back.svg" alt="Go Back">
          </router-link>

          <div class="do-article-slider">
            <slick ref="slick" :options="this.slickOptions" @init="handleInit">
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-400 mx-auto" src="static/images/article4-img1.png" alt="Innovation">
                        <figcaption class="mw-400 mx-auto">
                          <p>
                            <strong>Un’auto</strong> moderna, di circa 1.500 Kg, contiene dal <strong>12 al 15%</strong> di materie plastiche: circa <strong>200 kg</strong>, permettendo un risparmio di <strong>750 litri</strong> di <strong>carburante</strong> durante l’intero ciclo di vita. 
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-520 mx-0" src="static/images/article4-img2.png" alt="Innovation">
                        <figcaption class="mw-520">
                          <p>
                            <strong>Sostituire</strong> i prodotti di plastica con <strong>altri materiali</strong> richiederebbe circa il <strong>57% di energia in più</strong>. 
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-440 mx-auto" src="static/images/article4-img3.png" alt="Innovation">
                        <figcaption class="mw-440 mx-auto">
                         <p>
                          In Europa <strong>1.5 milioni di persone</strong> sono occupate nell’industria plastica in <strong>60.000 aziende</strong>.
                         </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-440 mx-auto" src="static/images/article4-img4.png" alt="Innovation">
                        <figcaption class="mw-460 mx-auto">
                          <p>
                            In <strong>Italia</strong>, <strong>145.000 persone</strong> sono occupate nell’industria plastica che genera <strong>40 miliardi di fatturato</strong>. 
                         </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-400 mx-auto" src="static/images/article4-img5.svg" alt="Innovation">
                        <figcaption class="mw-400 mx-auto">
                          <p>
                             In <strong>Italia</strong>, dal 2006 al 2016, il <strong>riciclo della plastica</strong> è aumentato del <strong>46%</strong>, il <strong>recupero energetico</strong> del <strong>53%</strong> e <strong>il ricorso in discarica</strong> è diminuito del <strong>49%</strong>.
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-420 mx-auto" src="static/images/article4-img6.svg" alt="Innovation">
                        <figcaption class="mw-420 mx-auto">
                          <p>
                            In <strong>Europa</strong>, dal 2006 al 2016, il <strong>riciclo della plastica</strong> è aumentato del <strong>79%</strong>, il <strong>recupero energetico</strong> del <strong>61%</strong> e il <strong>ricorso in discarica</strong> è diminuito del <strong>43%</strong>. 
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-380 mx-auto" src="static/images/article4-img7.svg" alt="Innovation">
                        <figcaption class="mw-380 mx-auto">
                          <p>
                            In <strong>Italia</strong>, i <strong>rifiuti in plastica</strong> rappresentano solo l’<strong>8%</strong> dei rifiuti urbani in termini di peso. 
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img class="mw-440 mx-auto" src="static/images/article4-img8.svg" alt="Innovation">
                        <figcaption class="mw-370 mx-auto">
                          <p>
                            <strong>Senza la plastica</strong> circa il <strong>50% dei prodotti alimentari</strong> si deteriora tra la <strong>raccolta</strong> e il consumo, con il <strong>packaging</strong> per alimenti in plastica, tale quantitativo si riduce al <strong>3%</strong>.
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img
                          class="mw-320 mx-auto"
                          src="static/images/article4-img9.svg"
                          alt="Innovation"
                        >
                        <figcaption class="mw-420 mx-auto">
                          <p>
                             L’<strong>isolamento</strong> realizzato con le <strong>materie plastiche</strong> permette enormi vantaggi: l’<strong>energia necessaria</strong> per la loro <strong>produzione</strong> viene <strong>ammortizzata</strong> con i <strong>risparmi energetici</strong> dei primi <strong>6 mesi d'uso</strong>.
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
              <!-- Slide -->
              <div class="do-slide">
                <div class="row h-100 align-content-center">
                  <div class="col-12">
                    <div class="do-figure-wrap">
                      <figure>
                        <img
                          class="mw-320"
                          src="static/images/article4-img10.png"
                          alt="Innovation"
                        >
                        <figcaption class="mw-340 mx-auto">
                          <p>
                           Più del <strong>27% di mele</strong> viene <strong>sprecato</strong> quando viene venduto sfuso cioè <strong>senza</strong> l'utilizzo di imballaggi di <strong>plastica</strong>.
                          </p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Slide -->
            </slick>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>



// WEBPACK FOOTER //
// src/components/Numeri.vue